// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper--1Rsjn {\n  position: relative;\n}[dir] .wrapper--1Rsjn {\n  margin-top: 20px;\n}\n\n[dir=ltr] .flagIcon--PvvYQ {\n  margin-left: 10px;\n}\n\n[dir=rtl] .flagIcon--PvvYQ {\n  margin-right: 10px;\n}\n", ""]);
// Exports
exports.locals = {
	"wrapper": "wrapper--1Rsjn",
	"flagIcon": "flagIcon--PvvYQ"
};
module.exports = exports;
